/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Typography,
  Box,
  Button,
  useMediaQuery,
  useTheme,
  Radio,
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  Divider,
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Card,
  Grid,
  CircularProgress,
} from "@mui/material";
import { connect } from "react-redux";
import { gaugeActions, homeActions } from "actions";
import RefillReminderPopUp from "./RefillReminderPopUp";
import SavedCouponPopUp from "./SavedCouponPopUp";
import DoseReminderPopUp from "./DoseReminderPopUp";
import SendTextMessagePopUp from "./SendTextMessagePopUp";
import SendEmailMessagePopUp from "./SendEmailMessagePopUp";
import SendHCPTextMessagePopUp from "./SendHCPTextMessagePopUp";
import SendHCPEmailMessagePopUp from "./SendHCPEmailMessagePopUp";
import MessageDialog from "./MessageDialog";
import RequestSignup from "./RequestSignup";
import {
  checkFavPharmacy,
  checkIfDTC,
  handleDTCFavPharmacy,
  hideCVDFavoriteView,
} from "pages/home/CommonFunctions";
import heartIcon from "assets/images/heartIcon/heart-30.png";
import heartFilledIcon from "assets/images/heartIcon/heart-filled-30.png";
import { config } from "../../constants";
import { authHeader } from "../../helpers";
import ProductInfo from "./ProductInfo";
import { gaugeService } from "../../services/gauge.service";
import ForwardToInbox from "assets/images/coupon-share.png";
import CouponQRCode from "../../components/CouponQRCode";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BrandedCouponDetails = (props) => {
  const {
    brandDetailsNew,
    saveCoupon,
    selectedInsurance,
    savedCouponInfo,
    resetSavedCouponInfo,
    deleteCoupon,
    deleteCouponInfo,
    resetDeleteCouponInfo,
    resetDoseReminderInfo,
    resetRefillReminderInfo,
    additionalStyles,
    resetBrandDetails,
    appQuantity,
    getBrandDetailsNew,
    resetDoseReminderData,
    resetRefillSavingsData,
    selectedBrandedInfo,
    organizationInfo,
    selectedItem,
    getProfile,
    updateGTMDataLayer,
    authData,
    pharmacyGroupList,
    showGauge = false,
    setSelectedItem = false,
    genericList,
    genericDetailsIsProgress,
    brandDetailsNewIsProgress,
    handleBackClick = null,
    fromPrescriptions = false,
    couponLowestPrice = null,
    savedDoseReminderInfo,
    savedRefillReminderInfo,
    contentInfo,
    couponData,
  } = props;

  const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matchesWidth = useMediaQuery("(max-width:600px)");
  const matchesminWidth = useMediaQuery("(max-width:350px)");

  const matches = useMediaQuery("(max-width:1200px)");

  const [showRefill, setShowRefill] = useState(false);
  const [showSaveSignUp, setShowSaveSignUp] = useState(false);
  const [showRefillSignUpCheck, setShowRefillSignUpCheck] = useState(false);
  const [showReminderSignUpCheck, setShowReminderSignUpCheck] = useState(false);
  const [showDoseReminder, setShowDoseReminder] = useState(false);
  const [showSendTextMessage, setShowSendTextMessage] = useState(false);
  const [showSendTextMessage1, setShowSendTextMessage1] = useState(false);
  const [showProductInfo, setShowProductInfo] = useState(false);
  const [showSendEmailMessage, setShowSendEmailMessage] = useState(false);
  const [showSendEmailMessage1, setShowSendEmailMessage1] = useState(false);

  const [isFromSavedCouponPopup, setIsFromSavedCouponPopup] = useState(false);

  const [successErrorMessage, setSuccessErrorMessage] = useState("");
  const [showSuccessErrorDialog, setShowSuccessErrorDialog] = useState(false);
  const [showAlreadySavedDialog, setShowAlreadySavedDialog] = useState(false);
  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");
  const isLoggedIn = JSON.parse(sessionStorage.getItem("isLoggedIn"));
  const dtcVisibility = handleDTCFavPharmacy(authData) && checkFavPharmacy();
  const iconTextVisibility = selectedItem?.favoritePharmacyFlag === "Y";
  const [favoriteIcon, setFavoriteIcon] = useState(
    iconTextVisibility || dtcVisibility ? heartFilledIcon : heartIcon
  );
  const btnText =
    iconTextVisibility || dtcVisibility
      ? "Unselect Favorite Pharmacy"
      : "Select Favorite Pharmacy";
  // eslint-disable-next-line no-unused-vars
  const [favoritePharmacyText, setFavoritePharmacyText] = useState(btnText);
  const showFavOptions =
    !hideCVDFavoriteView(authData) || dtcVisibility || checkIfDTC(authData);
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));

  // eslint-disable-next-line no-unused-vars
  const [pharmacyDetailPrice, setPharmacyDetailPrice] = useState(null);

  const [showTextCoupon, setShowTextCoupon] = useState(false);
  const [textCouponType, setTextCouponType] = useState(
    couponData?.qrCodeUrl ? "qrcode" : "text"
  );
  const [showPharmacyList, setShowPharmacyList] = useState(false);
  const [expanded, setExpanded] = React.useState(false);

  const [interstitialScreenContinue, setInterstitialScreenContinue] =
    useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
  const isPOSTemplate =
    organizationInfo?.type?.toLowerCase() === "p" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  const ref = sessionStorage.getItem("ref");

  const viewCouponRef = useRef(null);

  const widgetEnabled = sessionStorage.getItem("widgetEnabled");
  const [showQRCode, setShowQRCode] = useState(
    couponData?.qrCodeUrl ? true : false
  );
  const [showQRCode1, setShowQRCode1] = useState(
    couponData?.qrCodeUrl ? true : false
  );
  const radioBtnHandleChange = (
    event,
    defaultVal = couponData?.qrCodeUrl ? "qrcode" : "text"
  ) => {
    console.log("showTextCoupon", showTextCoupon);
    const val = event?.target?.value || defaultVal;
    setTextCouponType(val);
    setShowSendTextMessage(false);
    setShowSendEmailMessage(false);
    setShowQRCode(false);
    if (val === "qrcode") {
      setShowQRCode(true);
    } else if (val === "text") {
      setShowSendTextMessage(true);
    } else if (val === "email") {
      setShowSendEmailMessage(true);
    } else {
      setShowTextCoupon(false);
    }
  };

  const radioBtnHandleChangeFromPage = (
    event,
    defaultVal = couponData?.qrCodeUrl ? "qrcode" : "text"
  ) => {
    const val = event?.target?.value || defaultVal;
    setTextCouponType(val);
    setShowSendTextMessage1(val === "text");
    setShowSendEmailMessage1(val === "email");
    setShowQRCode1(val === "qrcode");
  };

  const radioControlProps = (item, type = "popup") => ({
    checked: textCouponType === item,
    onChange:
      type === "page" ? radioBtnHandleChangeFromPage : radioBtnHandleChange,
    value: item,
    name: "location-type-radio-button",
    inputProps: { "aria-label": item },
  });

  const autoOpenSharePopup = (type = "popup") => {
    let val = "";
    if (
      organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
      "y"
    ) {
      val = "text";
    } else if (
      organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
      "y"
    ) {
      val = "email";
    }
    if (val) {
      if (matches && type === "popup") {
        setShowTextCoupon(true);
      }
      type === "page"
        ? radioBtnHandleChangeFromPage(undefined, val)
        : radioBtnHandleChange(undefined, val);
    }
  };

  useEffect(() => {
    if (brandDetailsNew?.memberId) {
      if (
        organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
          "y" ||
        organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
          "y"
      ) {
        if (
          brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() === "y" ||
          brandDetailsNew?.interstitialScreenFlag?.toLowerCase() === "y"
        ) {
          // setTimeout(() => {
          //   autoOpenSharePopup();
          // }, 3000);
        } else {
          autoOpenSharePopup("page");
        }
      }

      updateGTMDataLayer({
        event: "View_Coupon_Copay",
        page: fromPrescriptions
          ? "Copay Coupon Card - Prescriptions"
          : "Copay Coupon Card",
        screen: fromPrescriptions
          ? "Copay Coupon Card - Prescriptions"
          : "Copay Coupon Card",
        screen_title: fromPrescriptions
          ? "Copay Coupon Card - Prescriptions"
          : "Copay Coupon Card",
        adjudication_id: brandDetailsNew && brandDetailsNew?.memberId,
        fromPrescriptions: fromPrescriptions ? "Y" : "N",
      });
    }

    if (
      brandDetailsNew?.pharmacyDetailPrice &&
      brandDetailsNew?.pharmacyDetailPrice.length
    ) {
      setPharmacyDetailPrice(brandDetailsNew?.pharmacyDetailPrice[0]);
    }
  }, [brandDetailsNew]);

  useEffect(() => {
    console.log("genericList", genericList, genericDetailsIsProgress);
    if (
      showFavOptions &&
      genericList &&
      genericList?.otherPharmacies &&
      !genericList?.favoritePharmacy &&
      !genericDetailsIsProgress
    ) {
      //fetchPharmacyGroupList(4000);
    }
    if (
      showFavOptions &&
      genericList &&
      !genericList?.otherPharmacies &&
      genericList?.favoritePharmacy &&
      !genericDetailsIsProgress
    ) {
      setFavoriteIcon(heartFilledIcon);
      setFavoritePharmacyText("Unselect Favorite Pharmacy");
    }
  }, [genericList]);

  useEffect(() => {
    return () => {
      resetBrandDetails();
      resetSavedCouponInfo();
      resetDeleteCouponInfo();
      resetDoseReminderInfo();
      resetRefillReminderInfo();
      resetDoseReminderData();
      resetRefillSavingsData();
      updateGTMDataLayer({
        event: "View_Coupon_Copay",
        page: fromPrescriptions
          ? "Copay Coupon Card - Prescriptions"
          : "Copay Coupon Card",
        screen: fromPrescriptions
          ? "Copay Coupon Card - Prescriptions"
          : "Copay Coupon Card",
        screen_title: fromPrescriptions
          ? "Copay Coupon Card - Prescriptions"
          : "Copay Coupon Card",
        screen_referrer: "Copay Coupon Card",
        fromPrescriptions: fromPrescriptions ? "Y" : "N",
      });
    };
  }, []);

  useEffect(() => {
    if (savedCouponInfo && savedCouponInfo.success) {
      setSuccessErrorMessage(savedCouponInfo.message);
      setShowSuccessErrorDialog(true);
    } else if (
      savedCouponInfo &&
      Object.keys(savedCouponInfo).length &&
      !savedCouponInfo.success
    ) {
      setShowSuccessErrorDialog(true);
      setSuccessErrorMessage(savedCouponInfo.message);
    }
  }, [savedCouponInfo]);

  const pdfUrlOpen = (event = null, type = "Auto open") => {
    window.open(
      brandDetailsNew?.pdfUrl,
      "_blank",
      "location=yes,height=570,width=1250, left=100, top=100, status=yes"
    );
    updateGTMDataLayer({
      event: "View_Coupon_Copay",
      page: fromPrescriptions
        ? "Copay Coupon Card - Prescriptions"
        : "Copay Coupon Card",
      screen: fromPrescriptions
        ? "Copay Coupon Card - Prescriptions"
        : "Copay Coupon Card",
      screen_title: fromPrescriptions
        ? "Copay Coupon Card - Prescriptions"
        : "Copay Coupon Card",
      adjudication_id: brandDetailsNew && brandDetailsNew?.memberId,
      fromPrescriptions: fromPrescriptions ? "Y" : "N",
      btnClick: event ? true : false,
      type: type,
    });
  };

  useEffect(() => {
    if (
      !brandDetailsNewIsProgress &&
      (brandDetailsNew?.productDetailId == selectedItem.productDetailId ||
        brandDetailsNew?.productDetailId ==
          selectedBrandedInfo?.productDetailId) &&
      brandDetailsNew?.pdfUrl &&
      (interstitialScreenContinue ||
        ref ||
        (brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() === "y" &&
          brandDetailsNew?.interstitialScreenFlag?.toLowerCase() === "n"))
    ) {
      viewCouponRef?.current?.click();
    }
  }, [brandDetailsNew?.pdfUrl, interstitialScreenContinue]);

  useEffect(() => {
    if (deleteCouponInfo && deleteCouponInfo.success) {
      setSuccessErrorMessage(deleteCouponInfo.message);
      setShowSuccessErrorDialog(true);
      resetSavedCouponInfo();
      resetDoseReminderInfo();
      resetRefillReminderInfo();
    } else if (
      deleteCouponInfo &&
      Object.keys(deleteCouponInfo).length &&
      !deleteCouponInfo.success
    ) {
      setShowSuccessErrorDialog(true);
      setSuccessErrorMessage(deleteCouponInfo.message);
    }
  }, [deleteCouponInfo]);

  useEffect(() => {
    console.log("selectedItem", selectedItem);
    getMyBrandedDetails();
  }, [selectedBrandedInfo, selectedItem]);

  useEffect(() => {
    if (
      fromPrescriptions &&
      selectedItem &&
      couponLowestPrice &&
      Object.keys(couponLowestPrice).length
    ) {
      const commericalInsData =
        contentInfo.INSURANCE_HELP_V2.contentParam.filter(
          (item) => item.value.type === "X"
        )[0];

      setInterstitialScreenContinue(false);
      getBrandDetailsNew({
        productDetailId: selectedItem?.productDetailId,
        offerId: couponLowestPrice?.offerId,
        insuranceId: commericalInsData?.value?.id,
        quantity: couponLowestPrice?.quantity || 0,
        zipCode: storedZipData?.zipCode,
        pharmacyLocationId: couponLowestPrice?.pharmacyLocationId,
        prescriptionFlag: fromPrescriptions ? "Y" : "N",
      });
    }
  }, [fromPrescriptions, couponLowestPrice]);

  const getMyBrandedDetails = async () => {
    if (
      !fromPrescriptions &&
      selectedBrandedInfo &&
      Object.keys(selectedBrandedInfo).length &&
      Object.keys(selectedItem).length &&
      !brandDetailsNewIsProgress
    ) {
      setInterstitialScreenContinue(false);
      let hasFavPharmacy = false;
      if (selectedItem?.triggerPharmacyNew) {
        setShowLoader(true);
        const pharmacyData = await gaugeService?.getGenericList({
          productDetailId: selectedBrandedInfo?.productDetailId,
          zipCode: storedZipData?.zipCode || selectedBrandedInfo?.zipCode,
          quantity: selectedBrandedInfo?.quantity,
          insuranceId: selectedBrandedInfo?.insuranceId || defaultInsuranceId,
          type: "M",
        });
        setShowLoader(false);
        const { favoritePharmacy = null } = pharmacyData?.data || {};
        if (favoritePharmacy !== null) {
          hasFavPharmacy = true;
          getBrandDetailsNew({
            productDetailId: selectedBrandedInfo?.productDetailId,
            offerId: favoritePharmacy?.offerId,
            insuranceId: selectedBrandedInfo?.insuranceId || defaultInsuranceId,
            quantity: selectedBrandedInfo?.quantity,
            zipCode: storedZipData?.zipCode || selectedBrandedInfo?.zipCode,
            pharmacyLocationId: favoritePharmacy?.pharmacyLocationId,
            prescriptionFlag: fromPrescriptions ? "Y" : "N",
          });
        } else if (
          selectedItem.pharmacyLocationId == null &&
          pharmacyData?.data?.otherPharmacies.length > 0
        ) {
          selectedItem.pharmacyLocationId =
            pharmacyData?.data?.otherPharmacies[0].pharmacyLocationId;
        }
      }
      setShowLoader(false);
      if (!hasFavPharmacy) {
        getBrandDetailsNew({
          productDetailId: selectedBrandedInfo.productDetailId,
          offerId: selectedItem.offerId,
          insuranceId: selectedBrandedInfo?.insuranceId || defaultInsuranceId,
          quantity: selectedBrandedInfo.quantity,
          zipCode: storedZipData?.zipCode,
          pharmacyLocationId: selectedItem.pharmacyLocationId,
          prescriptionFlag: fromPrescriptions ? "Y" : "N",
        });
      }
    }
  };

  const renderLogoView = (item) => {
    if (item && item.logoURL) {
      return (
        <img
          src={item && item.logoURL}
          alt="logo"
          style={{
            width: matchesMinWidth ? "60%" : "140px",
            height: matchesMinWidth ? "100%" : "25px",
          }}
        />
      );
    } else {
      return (
        <Typography
          variant="h3LatoBlack"
          sx={{ fontSize: matchesMinWidth ? "15px" : undefined }}
          component="span"
        >
          {item && item.pharmacyName}
        </Typography>
      );
    }
  };
  const markAsFavorite = async (item) => {
    const options = {
      baseURL: config.apiUrl,
      url: `/coupon/setfavoritepharmacy/${
        item.pharmacyLocationId || selectedItem.pharmacyLocationId
      }/${item.pharmacyGroupId || item.id}`,
      method: "GET",
      headers: authHeader(),
    };
    try {
      const response = await axios(options);
      if (response.status == 200) {
        setFavoriteIcon(() => alterFavoriteIcon());
        setFavoritePharmacyText("Unselect Favorite Pharmacy");
        localStorage.setItem(
          "pharmacyGroupId",
          item.pharmacyGroupId || item.id
        );
        localStorage.setItem(
          "pharmacyLocationId",
          item.pharmacyLocationId || selectedItem.pharmacyLocationId
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const alterFavoriteIcon = () => {
    if (favoriteIcon == heartIcon) {
      return heartFilledIcon;
    } else {
      return heartIcon;
    }
  };
  const handleClose = () => {
    setShowPharmacyList(false);
  };
  const renderPharmacyList = () => {
    return (
      <Box
        sx={{
          minHeight: "50px",
          maxHeight: "300px",
          overflowY: "auto",
          marginBottom: "1rem",
          padding: matches ? "0px" : "10px",
        }}
      >
        <Divider />
        {brandDetailsNew &&
          brandDetailsNew?.otherPharmacies &&
          brandDetailsNew?.otherPharmacies.map((item) => {
            return (
              <>
                <Box
                  sx={{
                    width: "100%",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  onClick={async () => {
                    await setSelectedItem(item);
                    await setPharmacyDetailPrice(item);
                    setExpanded(false);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box sx={{ alignItems: "center", display: "flex" }}>
                      {renderLogoView(item)}
                      {genericList?.favoritePharmacy?.pharmacyGroupId ===
                        item?.pharmacyGroupId && (
                        <img
                          className="fav-heart-icon"
                          src={heartFilledIcon}
                          alt="Favorite Icon"
                        />
                      )}
                    </Box>
                  </Box>
                  {item.pharmacyType !== "M" && (
                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Typography
                      variant="h4LatoMedium"
                      component="div"
                      sx={{
                        color: theme.palette.common.textGrey2,
                        width: "90%",
                      }}
                    >
                      {item && item.distance?.toFixed(2)} mi
                    </Typography>
                  </Box>
                  )}
                </Box>
                <Divider />
              </>
            );
          })}
      </Box>
    );
  };

  const renderPharmacyListDiaglog = () => {
    return (
      <Box
        sx={{
          minHeight: "50px",
          maxHeight: "300px",
          overflowY: "auto",
          marginBottom: "1rem",
          padding: matches ? "0px" : "10px",
        }}
      >
        <Divider />
        {pharmacyGroupList &&
          pharmacyGroupList.length &&
          pharmacyGroupList.map((item) => {
            return (
              <>
                <Box
                  sx={{
                    width: "100%",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  onClick={async () => {
                    await setSelectedItem(item);
                    await setPharmacyDetailPrice(item);
                    markAsFavorite(item);
                    handleClose();
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        height: "40px",
                      }}
                    >
                      {renderLogoView(item)}
                    </Box>
                    <Box component="span">
                      <img
                        className="fav-heart-icon"
                        src={heartIcon}
                        alt="Favorite Icon"
                        onMouseOver={(e) => {
                          e.target.src = heartFilledIcon;
                        }}
                        onMouseOut={(e) => {
                          e.target.src = heartIcon;
                        }}
                      />
                    </Box>
                  </Box>
                  {item.pharmacyType !== "M" && (
                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Typography
                      variant="h4LatoMedium"
                      component="div"
                      sx={{
                        color: theme.palette.common.textGrey2,
                        width: "90%",
                      }}
                    >
                      {item && item.distance?.toFixed(2)} mi &nbsp;
                    </Typography>
                  </Box>
                  )}
                </Box>
                <Divider />
              </>
            );
          })}
      </Box>
    );
  };

  const couponHead = () => {
    return (
      <>
        <Grid pb={2}>
          {brandDetailsNew?.offerEnrollmentText && (
            <Typography
              variant={"regularText1"}
              sx={{
                textAlign: "center",
                color: `${
                  organizationInfo?.colorSchemeJson?.stepsTextColor || "#093d4c"
                }`,
                fontSize: matches ? "16px" : "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              component={"div"}
            >
              {brandDetailsNew?.offerEnrollmentText}
            </Typography>
          )}
          {brandDetailsNew?.offerText && (
            <Typography
              sx={{
                textAlign: "center",
                color: `${
                  organizationInfo?.colorSchemeJson?.stepsTextColor || "#093d4c"
                }`,
                fontSize: "26px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              component={"div"}
            >
              <span>{brandDetailsNew?.offerText}<sup>*</sup></span>
            </Typography>
          )}
          {brandDetailsNew?.offerEnrollmentStepText &&
            brandDetailsNew?.offerEnrollmentStepText?.length > 0 && (
              <Grid
                sx={{
                  //marginTop: matches ? "-15px" : "-10px",
                  padding: matchesMinWidth
                    ? undefined
                    : isPOSTemplate
                    ? "0px 10% 0px 15%"
                    : undefined,
                }}
                mt={-1}
                container
                spacing={2}
                columns={16}
              >
                {brandDetailsNew?.offerEnrollmentStepText?.map(
                  (item, index) => (
                    <Grid
                      key={"step_" + index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        margin: "0px auto 0px auto",
                        paddingLeft: !isPOSTemplate
                          ? matchesMinWidth
                            ? "1% !important"
                            : "18% !important"
                          : index % 2 === 0
                          ? "auto"
                          : "5px !important",
                        justifyContent: !isPOSTemplate
                          ? "flex-start"
                          : undefined,
                      }}
                      item
                      xs={isPOSTemplate ? 8 : 12}
                    >
                      <div
                        style={{
                          width: "25px",
                          height: "25px",
                          border: `solid 1px ${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          backgroundColor: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                          borderRadius: "50%",
                          color: "#fff",
                          marginRight: matches ? "5px" : "10px",
                        }}
                      >
                        <Typography
                          variant={"footerText"}
                          sx={{
                            width: "25px",
                            height: "25px",
                            border: `solid 1px ${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                            alignItems: "center",
                            justifyContent: "center",
                            display: "flex",
                            backgroundColor: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                            borderRadius: "50%",
                            color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                            fontSize: matchesminWidth
                              ? "10px"
                              : matchesWidth
                              ? "10px"
                              : "15px",
                          }}
                        >
                          {index + 1}
                        </Typography>
                      </div>
                      <Typography
                        variant={matches ? "footerText" : "footerText"}
                        sx={{
                          color: `${
                            organizationInfo?.colorSchemeJson?.stepsTextColor ||
                            "#093d4c"
                          }`,
                          // letterSpacing: matchesWidth ? "0.2px" : "0.6px",
                          // lineHeight: matchesSmallestWidth ? undefined : "20px",
                          fontSize: matchesminWidth
                            ? "10px"
                            : matchesWidth
                            ? "10px"
                            : "15px",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        {item}
                      </Typography>
                    </Grid>
                  )
                )}
              </Grid>
            )}
        </Grid>
      </>
    );
  };

  const couponTextHeader = (type = "popup") => {
    if (
      organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
        "y" &&
      organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
        "y"
    ) {
      return (
        <>
          <Typography
            variant="h2LatoBold"
            sx={{
              paddingLeft: "5px",
              color: `${
                organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color ||
                "#46bc23"
              }`,
              fontSize: matchesMinWidth ? "18px" : "26px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            {isHCPTemplate
              ? "Share savings with patient"
              : textCouponType === "text"
              ? "Text me coupon to show pharmacy"
              : textCouponType === "qrcode"
              ? "QR Code to show pharmacy"
              : "Email me coupon to show pharmacy"}
          </Typography>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            {couponData?.qrCodeUrl && (
              <>
                <Radio {...radioControlProps("qrcode", type)} color="success" />
                <Typography
                  variant="h2LatoMedium"
                  sx={{
                    fontWeight: 500,
                    fontSize: 16,
                    textAlign: "center",
                    color: "#607277",
                  }}
                >
                  QR Code
                </Typography>
              </>
            )}

            <Radio {...radioControlProps("text", type)} color="success" />
            <Typography
              variant="h2LatoMedium"
              sx={{
                fontWeight: 500,
                fontSize: 16,
                textAlign: "center",
                color: "#607277",
              }}
            >
              Text
            </Typography>
            <Radio {...radioControlProps("email", type)} color="success" />
            <Typography
              variant="h2LatoMedium"
              sx={{
                fontWeight: 500,
                fontSize: 16,
                textAlign: "center",
                color: "#607277",
              }}
            >
              Email
            </Typography>
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <>
      {brandDetailsNewIsProgress || showLoader ? (
        <div
          style={{
            height: "300px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <CircularProgress
            style={{ color: theme?.palette?.secondary?.main }}
          />
        </div>
      ) : (
        <Box
          sx={{
            padding:
              brandDetailsNew?.interstitialScreenFlag === "Y" &&
              !interstitialScreenContinue
                ? "1% 9%"
                : matches
                ? "0% 2% 0% 8%"
                : "0% 5% 0% 5%",
          }}
        >
          {brandDetailsNew?.interstitialScreenFlag === "Y" &&
            !interstitialScreenContinue && (
              <>
                {couponHead()}
                <Card sx={{ height: matches ? "415px" : "340px" }}>
                  <Box
                    sx={{ padding: "2%", paddingTop: "15px", height: "100%" }}
                  >
                    <Typography
                      variant="h2LatoBold"
                      sx={{
                        textAlign: "center",
                        fontSize: matchesMinWidth ? "18px" : "22px",
                        color: "#083d4c",
                        opacity: "0.8",
                        lineHeight: matches ? "27px" : "30px",
                        display: "flex",
                        justifyContent: "center",
                        height:
                          brandDetailsNew?.interstitialScreenText?.title
                            ?.length > 0
                            ? "35px"
                            : undefined,
                      }}
                    >
                      {brandDetailsNew?.interstitialScreenText?.title}
                    </Typography>
                    <Typography
                      variant="h2LatoRegular"
                      sx={{
                        fontSize: matchesMinWidth ? "14px" : "18px",
                        color: "#000",
                        opacity: "0.8",
                        lineHeight: matches ? "27px" : "30px",
                        textAlign: "center",
                        display: "block",
                        height: "80%",
                        paddingTop: "4%",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: brandDetailsNew?.interstitialScreenText?.body,
                      }}
                    />
                    <Box
                      sx={{ display: "flex", justifyContent: "space-around" }}
                    >
                      <Button
                        variant="outline"
                        sx={{
                          minWidth: matches ? "100px" : "250px",
                          fontFamily: "Lato-Bold",
                        }}
                        onClick={() => {
                          handleBackClick && handleBackClick();
                        }}
                      >
                        GO BACK
                      </Button>
                      <Button
                        variant="outline"
                        sx={{
                          minWidth: matches ? "100px" : "250px",
                          fontFamily: "Lato-Bold",
                        }}
                        onClick={() => {
                          setInterstitialScreenContinue(true);
                        }}
                      >
                        CONTINUE
                      </Button>
                    </Box>
                  </Box>
                </Card>
              </>
            )}
          {(brandDetailsNew?.interstitialScreenFlag === "N" ||
            interstitialScreenContinue) && (
            <>
              <Accordion
                expanded={expanded}
                style={{
                  border: "1px solid #ccc",
                  width: "100%",
                  margin: matchesMinWidth ? "2% 0% 3% -4%" : "1% 0% 0% -3%",
                }}
              >
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ backgroundColor: "transparent" }}
                >
                  <Box sx={{ width: "100%" }}>
                    {couponHead()}
                    {!expanded && (
                      <Box
                        id="ViewCouponCopay"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          minHeight: matches ? "265px" : "320px",
                        }}
                      >
                        <Box
                          sx={{
                            border: `2px solid ${
                              organizationInfo?.colorSchemeJson?.gaugeColor
                                ?.wedge3Color || "#46bc23"
                            }`,
                            padding: matches
                              ? "0px 25px 15px 25px"
                              : "32px 32px 5px 32px",
                            borderRadius: "18px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: matches ? "250px" : "320px",
                          }}
                        >
                          {brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() ===
                            "y" ||
                          brandDetailsNew?.interstitialScreenFlag?.toLowerCase() ===
                            "y" ? (
                            <>
                              {matches &&
                                (organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
                                  "y" ||
                                  organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
                                    "y") && (
                                  <div
                                    style={{ width: "50px !important" }}
                                    id="sticky"
                                    className={
                                      isPOSTemplate
                                        ? "sticky-front-branded-pos"
                                        : "sticky-front-branded"
                                    }
                                  >
                                    <img
                                      alt="Text Coupon"
                                      onClick={() => {
                                        if (
                                          organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
                                            "y" ||
                                          organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
                                            "y"
                                        ) {
                                          setShowTextCoupon(true);

                                          couponData?.qrCodeUrl
                                            ? setShowQRCode(true)
                                            : setShowSendTextMessage(true);

                                          setTextCouponType(
                                            couponData?.qrCodeUrl
                                              ? "qrcode"
                                              : "text"
                                          );
                                        }
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        width: "100%",
                                      }}
                                      src={ForwardToInbox}
                                    />
                                  </div>
                                )}

                              <Box
                                mt={matches ? 0 : 3}
                                mb={matches ? 1 : 3}
                                sx={{ textAlign: "center", maxWidth: "450px" }}
                              >
                                <Typography variant="h2LatoMedium">
                                  Use the "VIEW SAVINGS" button to open the
                                  copay coupon from the manufacturer's website
                                  in another window.
                                </Typography>
                              </Box>

                              <Box>
                                <Button
                                  variant="large"
                                  sx={{ minWidth: matchesMinWidth ? 200 : 400 }}
                                  onClick={(event) => {
                                    pdfUrlOpen(event, "View savings");
                                  }}
                                  ref={viewCouponRef}
                                >
                                  VIEW SAVINGS
                                </Button>
                              </Box>
                              <Box mt={1} sx={{ textAlign: "center" }}>
                                <Typography
                                  variant="h2LatoMediumNew"
                                  sx={{
                                    fontSize: matchesMinWidth ? "12px" : "16px",
                                    color: "lightslategray",
                                  }}
                                >
                                  Turn off Pop up Blocker
                                </Typography>
                              </Box>
                            </>
                          ) : (
                            <>
                              {couponTextHeader("page")}
                              {showQRCode1 && (
                                <CouponQRCode
                                  hideOkBtn={
                                    brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() ===
                                      "y" ||
                                    brandDetailsNew?.interstitialScreenFlag?.toLowerCase() ===
                                      "y"
                                  }
                                  popupContentOnly={true}
                                  onCancel={() => {
                                    setShowQRCode1(false);
                                    setShowTextCoupon(false);
                                  }}
                                />
                              )}
                              {showSendTextMessage1 && !isHCPTemplate && (
                                <SendTextMessagePopUp
                                  fromBranded={true}
                                  showTextCoupon={true}
                                  showSendTextMessage={showSendTextMessage}
                                  onCancel={() => {
                                    setShowSendTextMessage1(false);
                                    setShowTextCoupon(false);
                                  }}
                                />
                              )}
                              {showSendTextMessage1 && isHCPTemplate && (
                                <SendHCPTextMessagePopUp
                                  couponData={selectedBrandedInfo}
                                  showTextCoupon={true}
                                  shareCoupon={true}
                                  showSendTextMessage={showSendTextMessage}
                                  shareApp={false}
                                  onCancel={() => {
                                    setShowSendTextMessage1(true);
                                    //setShowTextCoupon(false);
                                  }}
                                  disableCancelBtn={true}
                                />
                              )}
                              {showSendEmailMessage1 && !isHCPTemplate && (
                                <SendEmailMessagePopUp
                                  fromBranded={true}
                                  showTextCoupon={true}
                                  showSendEmailMessage={showSendEmailMessage}
                                  onCancel={() => {
                                    setShowSendEmailMessage1(false);
                                    setShowTextCoupon(false);
                                  }}
                                />
                              )}
                              {showSendEmailMessage1 && isHCPTemplate && (
                                <SendHCPEmailMessagePopUp
                                  couponData={selectedBrandedInfo}
                                  showTextCoupon={true}
                                  shareCoupon={true}
                                  shareApp={false}
                                  showSendEmailMessage={showSendEmailMessage1}
                                  onCancel={() => {
                                    setShowSendEmailMessage1(true);
                                  }}
                                  disableCancelBtn={true}
                                />
                              )}
                            </>
                          )}
                        </Box>

                        {!(
                          brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() ===
                            "y" ||
                          brandDetailsNew?.interstitialScreenFlag?.toLowerCase() ===
                            "y"
                        ) && (
                          <Box mt={2} mb={2}>
                            <Typography
                              component={"div"}
                              onClick={(event) => {
                                pdfUrlOpen(event, "View Coupon");
                              }}
                              variant="h2LatoRegular"
                              sx={{
                                cursor: "pointer",
                                fontSize: matchesMinWidth ? "16px" : "20px",
                                color: ` ${
                                  organizationInfo?.colorSchemeJson?.gaugeColor
                                    ?.wedge3Color || "#46bc23"
                                }`,
                                textAlign: "center",
                              }}
                            >
                              View Coupon
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    )}
                    <Typography
                      variant={matches ? "footerText" : "footerText"}
                      sx={{
                        textAlign: "center",
                        color: `${
                          organizationInfo?.colorSchemeJson?.stepsTextColor ||
                          "#093d4c"
                        }`,
                        fontSize: "12px",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        lineHeight: "1rem",
                        padding: "5px",
                      }}
                      component={"div"}
                    >
                      *Governmental beneficiaries excluded, terms and conditions
                      apply.
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>{renderPharmacyList()}</AccordionDetails>
              </Accordion>
              <Box
                sx={{
                  position: "relative",
                  padding: "19px",
                  backgroundColor: matchesMinWidth ? "#FFF" : "#FFF",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    // flexDirection: matches ? "column" : undefined,
                    justifyContent: matches ? "center" : "space-evenly",
                    alignItems: matches ? "center" : undefined,
                    ...additionalStyles,
                    width: "100%",
                  }}
                >
                  {!matches && (
                    <>
                      {organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
                        "y" &&
                        (brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() ===
                          "y" ||
                          brandDetailsNew?.interstitialScreenFlag?.toLowerCase() ===
                            "y") && (
                          <Box
                            mb={matches ? 2 : undefined}
                            sx={{
                              width: matches ? "21%" : undefined,
                              marginRight: 0.5,
                              height: matches ? "3.4rem" : undefined,
                            }}
                          >
                            <Button
                              variant="filled"
                              sx={{
                                padding: matches ? "0px" : undefined,
                                minWidth: matches ? "100%" : undefined,
                                height: "100%",
                              }}
                              onClick={() => setShowSendTextMessage(true)}
                            >
                              <Typography
                                sx={{
                                  fontSize: matches ? "12px" : undefined,
                                }}
                                variant="text3"
                              >
                                Text
                              </Typography>
                            </Button>
                          </Box>
                        )}
                      {organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
                        "y" &&
                        (brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() ===
                          "y" ||
                          brandDetailsNew?.interstitialScreenFlag?.toLowerCase() ===
                            "y") && (
                          <Box
                            mb={matches ? 2 : undefined}
                            sx={{
                              width: matches ? "21%" : undefined,
                              marginRight: 0.5,
                              height: matches ? "3.4rem" : undefined,
                            }}
                          >
                            <Button
                              variant="filled"
                              sx={{
                                padding: matches ? "0px" : undefined,
                                minWidth: matches ? "100%" : undefined,
                                height: "100%",
                              }}
                              onClick={() => setShowSendEmailMessage(true)}
                            >
                              <Typography
                                sx={{
                                  fontSize: matches ? "12px" : undefined,
                                }}
                                variant="text3"
                              >
                                Email
                              </Typography>
                            </Button>
                          </Box>
                        )}
                    </>
                  )}
                  {widgetEnabled?.toLowerCase() === "n" &&
                    organizationInfo?.organizationOptionJson?.saveCouponFlag?.toLowerCase() ===
                      "y" && (
                      <Box
                        mb={matches ? 2 : undefined}
                        sx={{
                          width: matches ? "21%" : undefined,
                          marginRight: 0.5,
                          height: matches ? "3.4rem" : undefined,
                        }}
                      >
                        <Button
                          variant="filled"
                          sx={{
                            padding: matches ? "0px" : undefined,
                            minWidth: matches ? "100%" : undefined,
                            height: "100%",
                            border:
                              (savedCouponInfo?.data ||
                                savedDoseReminderInfo?.data ||
                                savedRefillReminderInfo?.data ||
                                brandDetailsNew?.savedFlag === "Y" ||
                                brandDetailsNew.doseReminderFlag === "Y" ||
                                brandDetailsNew?.refillReminderFlag === "Y") &&
                              !deleteCouponInfo?.data
                                ? "2px solid #093d4c"
                                : "none",
                          }}
                          onClick={() => {
                            if (isLoggedIn) {
                              if (
                                brandDetailsNew?.savedFlag === "Y" ||
                                brandDetailsNew?.doseReminderFlag === "Y" ||
                                brandDetailsNew?.refillReminderFlag === "Y" ||
                                (savedCouponInfo && savedCouponInfo.success)
                              ) {
                                setShowAlreadySavedDialog(true);
                              } else {
                                saveCoupon({
                                  insuranceId: selectedInsurance?.id,
                                  productDetailId:
                                    brandDetailsNew?.productDetailId,
                                  pharmacyLocationId:
                                    selectedItem?.pharmacyLocationId || -1,
                                  quantity: appQuantity,
                                  couponType:
                                    selectedItem?.couponType ||
                                    selectedItem?.discountType,
                                });
                                setIsFromSavedCouponPopup(false);
                              }
                            } else {
                              setShowSaveSignUp(true);
                            }
                          }}
                        >
                          <Typography
                            sx={{ fontSize: matches ? "12px" : undefined }}
                            variant="text3"
                          >
                            Save Coupon
                          </Typography>
                        </Button>
                      </Box>
                    )}
                  {widgetEnabled?.toLowerCase() === "n" &&
                    organizationInfo?.organizationOptionJson?.doseReminderFlag?.toLowerCase() ===
                      "y" && (
                      <Box
                        mb={matches ? 2 : undefined}
                        sx={{
                          width: matches ? "21%" : undefined,
                          marginRight: 0.5,
                          height: matches ? "3.4rem" : undefined,
                        }}
                      >
                        <Button
                          variant="filled"
                          sx={{
                            paddingLeft: matches ? "0px" : undefined,
                            paddingRight: matches ? "0px" : undefined,
                            minWidth: matches ? "100%" : undefined,
                            border:
                              (savedDoseReminderInfo?.data ||
                                brandDetailsNew.doseReminderFlag?.toLowerCase() ===
                                  "y") &&
                              !deleteCouponInfo?.data
                                ? "2px solid #093d4c"
                                : "none",
                            height: "100%",
                          }}
                          onClick={() => {
                            if (isLoggedIn) {
                              setShowDoseReminder(true);
                            } else {
                              setShowReminderSignUpCheck(true);
                            }
                          }}
                        >
                          <Typography
                            sx={{ fontSize: matches ? "12px" : undefined }}
                            variant="text3"
                          >
                            Daily Dose Reminder
                          </Typography>
                        </Button>
                      </Box>
                    )}
                  {widgetEnabled?.toLowerCase() === "n" &&
                    organizationInfo?.organizationOptionJson?.refillSavingsFlag?.toLowerCase() ===
                      "y" && (
                      <Box
                        mb={matches ? 2 : undefined}
                        sx={{
                          width: matches ? "21%" : undefined,
                          marginRight: 0.5,
                          height: matches ? "3.4rem" : undefined,
                        }}
                      >
                        <Button
                          variant="filled"
                          sx={{
                            padding: matches ? "0px" : undefined,
                            paddingLeft: matches ? "0px" : undefined,
                            paddingRight: matches ? "0px" : undefined,
                            minWidth: matches ? "100%" : undefined,
                            height: "100%",
                            border:
                              (savedRefillReminderInfo?.data ||
                                brandDetailsNew?.refillReminderFlag?.toLowerCase() ===
                                  "y") &&
                              !deleteCouponInfo?.data
                                ? "2px solid #093d4c"
                                : "none",
                          }}
                          onClick={() => {
                            if (isLoggedIn) {
                              setShowRefill(true);
                              getProfile();
                            } else {
                              setShowRefillSignUpCheck(true);
                            }
                          }}
                        >
                          <Typography
                            sx={{ fontSize: matches ? "12px" : undefined }}
                            variant="text3"
                          >
                            Refill Savings
                          </Typography>
                        </Button>
                      </Box>
                    )}
                  {widgetEnabled?.toLowerCase() === "n" &&
                    organizationInfo?.organizationOptionJson?.productInfoFlag?.toLowerCase() ===
                      "y" && (
                      <Box
                        mb={matches ? 2 : undefined}
                        sx={{
                          width: matches ? "21%" : undefined,
                          marginRight: 0.5,
                          height: matches ? "3.4rem" : undefined,
                        }}
                      >
                        <Button
                          variant="filled"
                          sx={{
                            minWidth: matches ? "100%" : undefined,
                            height: "100%",
                            padding: matches ? "0px" : undefined,
                          }}
                          onClick={() => setShowProductInfo(true)}
                        >
                          <Typography
                            sx={{ fontSize: matches ? "12px" : undefined }}
                            variant="text3"
                          >
                            Product Info
                          </Typography>
                          {/* <IosShareIcon /> */}
                        </Button>
                      </Box>
                    )}

                  {matches &&
                    (organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
                      "y" ||
                      organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
                        "y") &&
                    (brandDetailsNew?.offerAutoOpenFlag?.toLowerCase() ===
                      "y" ||
                      brandDetailsNew?.interstitialScreenFlag?.toLowerCase() ===
                        "y") && (
                      <Box
                        mb={matches ? 2 : undefined}
                        sx={{
                          width: matches ? "21%" : undefined,
                          marginRight: 0.5,
                          height: matches ? "3.4rem" : undefined,
                        }}
                      >
                        <Button
                          variant="filled"
                          sx={{
                            minWidth: matches ? "100%" : undefined,
                            height: "100%",
                            padding: matches ? "0px" : undefined,
                          }}
                          onClick={() => {
                            setShowTextCoupon(true);
                            setShowSendTextMessage(true);
                            setTextCouponType("text");
                          }}
                        >
                          <Typography
                            sx={{ fontSize: matches ? "12px" : undefined }}
                            variant="text3"
                          >
                            Text Coupon
                          </Typography>
                          {/* <IosShareIcon /> */}
                        </Button>
                      </Box>
                    )}
                </Box>
              </Box>
            </>
          )}
          {showSaveSignUp ? (
            <RequestSignup
              onButtonClick={() => setShowSaveSignUp(false)}
              titleInfo={`Cuverd finds and saves free coupons that ${
                matchesMinWidth ? "" : "<br />"
              } work at your local pharmacy.`}
              showPopUp={showSaveSignUp}
            />
          ) : null}
          {showRefill ? (
            <RefillReminderPopUp
              onCancel={() => {
                // getMyBrandedDetails();
                setShowRefill(false);
              }}
              showRefill={showRefill}
            />
          ) : null}

          {showRefillSignUpCheck ? (
            <RequestSignup
              onButtonClick={() => setShowRefillSignUpCheck(false)}
              titleInfo={`Get helpful refill savings reminders to keep you ${
                matchesMinWidth ? "" : "<br />"
              } on track by signing up for a Cuverd account.`}
              showPopUp={showRefillSignUpCheck}
            />
          ) : null}

          {showDoseReminder ? (
            <DoseReminderPopUp
              onCancel={() => {
                // getMyBrandedDetails();
                setShowDoseReminder(false);
              }}
              showDoseReminder={showDoseReminder}
            />
          ) : null}
          {showReminderSignUpCheck ? (
            <RequestSignup
              onButtonClick={() => setShowReminderSignUpCheck(false)}
              titleInfo={`Cuverd can remind you when it’s ${
                matchesMinWidth ? "" : "<br />"
              } time to take your medication.`}
              showPopUp={showReminderSignUpCheck}
            />
          ) : null}

          {showTextCoupon && (
            <Dialog open={true} className="app-dialog" onClose={() => {}}>
              <DialogContent sx={{ padding: "15px 24px 0px 24px" }}>
                {couponTextHeader()}
              </DialogContent>
              {showQRCode && (
                <CouponQRCode
                  popupContentOnly={true}
                  onCancel={() => {
                    setShowQRCode(false);
                    setShowTextCoupon(false);
                  }}
                />
              )}
              {showSendTextMessage && (
                <SendTextMessagePopUp
                  showTextCoupon={showTextCoupon}
                  showSendTextMessage={showSendTextMessage}
                  onCancel={() => {
                    setShowSendTextMessage(false);
                    setShowTextCoupon(false);
                  }}
                />
              )}
              {showSendEmailMessage && (
                <SendEmailMessagePopUp
                  showTextCoupon={showTextCoupon}
                  showSendEmailMessage={showSendEmailMessage}
                  onCancel={() => {
                    setShowSendEmailMessage(false);
                    setShowTextCoupon(false);
                  }}
                />
              )}
            </Dialog>
          )}

          {showSendTextMessage && !showTextCoupon && (
            <SendTextMessagePopUp
              showSendTextMessage={showSendTextMessage}
              onCancel={() => setShowSendTextMessage(false)}
            />
          )}

          {showSendEmailMessage && !showTextCoupon && (
            <SendEmailMessagePopUp
              showSendEmailMessage={showSendEmailMessage}
              onCancel={() => setShowSendEmailMessage(false)}
            />
          )}

          {showProductInfo && (
            <ProductInfo
              productDetailId={selectedBrandedInfo?.productDetailId || selectedItem?.productDetailId}
              showProductInfo={showProductInfo}
              onCancel={() => setShowProductInfo(false)}
            />
          )}

          {showSuccessErrorDialog ? (
            <MessageDialog showPopUp={showSuccessErrorDialog}>
              <Box mb={7}>
                <Typography variant="h2LatoHeavy">
                  {successErrorMessage}
                </Typography>
              </Box>
              <Box>
                <Button
                  variant="large"
                  onClick={() => {
                    // getMyBrandedDetails();
                    //resetDeleteCouponInfo();
                    setShowSuccessErrorDialog(false);
                  }}
                  sx={{ minWidth: { xs: "150px", sm: "150px", md: "100%" } }}
                >
                  DONE
                </Button>
              </Box>
              {!isFromSavedCouponPopup ? (
                <Box mt={2}>
                  <Button
                    variant="text"
                    onClick={() => {
                      // Here the type of data should be a number like
                      // data: 945, message: "This coupon has been saved."success: true
                      deleteCoupon(savedCouponInfo?.data);
                      setIsFromSavedCouponPopup(true);
                      setShowSuccessErrorDialog(false);
                    }}
                    sx={{ minWidth: { xs: "150px", sm: "150px", md: "100%" } }}
                  >
                    UNDO
                  </Button>
                </Box>
              ) : null}
            </MessageDialog>
          ) : null}

          {showAlreadySavedDialog ? (
            <SavedCouponPopUp
              showPopUp={showAlreadySavedDialog}
              onDeleteClick={() => {
                setIsFromSavedCouponPopup(true);
                setShowAlreadySavedDialog(false);
                deleteCoupon(brandDetailsNew?.savedCouponId);
              }}
              onCancelClick={() => setShowAlreadySavedDialog(false)}
            />
          ) : null}
          {!showGauge && !fromPrescriptions && (
            <Dialog
              fullWidth={true}
              maxWidth={"sm"}
              open={showPharmacyList}
              className="app-dialog"
              TransitionComponent={Transition}
              sx={{
                position: "absolute",
                top: matches ? "350px" : "10%",
                height: matches ? "400px" : undefined,
              }}
            >
              <DialogTitle sx={{ textAlign: "center" }}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h2LatoBlackNew"
                    sx={{
                      //color: "#03952a",
                      lineHeight: "1",
                      fontSize: matchesMinWidth ? "18px" : "24px",
                    }}
                  >
                    Pick your favorite pharmacy
                  </Typography>
                </Box>
                <Box px={1} sx={{ textAlign: "center", lineHeight: "1" }}>
                  <Typography
                    variant="h3LatoBold"
                    sx={{ color: "#2C4980", lineHeight: "1", fontSize: "12px" }}
                  >
                    (we'll check the best prices there versus others)
                  </Typography>
                </Box>
              </DialogTitle>
              <DialogContent
                sx={{
                  padding: "0px 30px",
                }}
              >
                {renderPharmacyListDiaglog()}
              </DialogContent>
            </Dialog>
          )}
        </Box>
      )}
    </>
  );
};

function mapStateToProps(state) {
  return {
    brandDetailsNew: state.brandDetailsNew.data || {},
    brandDetailsNewIsProgress: state.brandDetailsNew.isProgress,
    selectedInsurance: state.insuranceList.selectedInsurance || {},
    selectedProduct: state.home.selectedProduct,
    savedCouponInfo: state.savedCouponInfo.data,
    savedDoseReminderInfo: state.savedDoseReminderInfo.data,
    savedRefillReminderInfo: state.savedRefillReminderInfo.data,
    productDetailId: state.productDetails.productDetailId,
    couponData: state.couponPrice.data,
    deleteCouponInfo: state.deleteCouponInfo.data,
    appQuantity: state.productDetails.appQuantity,
    organizationInfo: state.organizationInfo.data,
    selectedBrandedInfo: state.globalStoreInfo.selectedBrandedInfo,
    authData: state.authentication.authData || {},
    pharmacyGroupList: state.pharmacyGroupList.data || [],
    selectedGenericInfo: state.globalStoreInfo.selectedGenericInfo,
    zipData: state.zipData.data,
    genericDetails: state.genericDetails.data,
    genericList: state.genericList.data,
    genericDetailsIsProgress: state.genericDetails.isProgress,
    contentInfo: state.contentType.data,
  };
}

const mapDispatchToProps = {
  getProfile: () => homeActions.getProfile(),
  resetData: (value) => homeActions.resetData(value),
  resetSavedCouponInfo: (value) => homeActions.resetSavedCouponInfo(value),
  saveCoupon: (params) => homeActions.saveCoupon(params),
  deleteCoupon: (value) => homeActions.deleteCoupon(value),
  getBrandDetailsNew: (params) => gaugeActions.getBrandDetailsNew(params),
  resetDeleteCouponInfo: () => homeActions.resetDeleteCouponInfo(),
  resetDoseReminderInfo: () => homeActions.resetDoseReminderInfo(),
  resetRefillReminderInfo: () => homeActions.resetRefillReminderInfo(),
  resetDoseReminderData: () => homeActions.resetDoseReminderData(),
  resetRefillSavingsData: () => homeActions.resetRefillSavingsData(),
  resetBrandDetails: () => gaugeActions.resetBrandDetails(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  getPharmacyGroup: (value) => gaugeActions.getPharmacyGroup(value),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrandedCouponDetails);
